export default "assets/images/icons/phone-3fad3a3b.svg";